import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import './App.css';
import Layout from './page/Layout';

import store from './redux/store';

function App() {



 
  return (
    <>
     <Toaster />
      <Provider store={store}>
      <Layout/>
      </Provider>

    </>
  );
}

export default App;
